import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPage } from './pages/login/login.page';
import { AuthenticatePage } from './pages/authenticate/authenticate.page';
import { ResetPasswordPage } from './pages/reset-password/reset-password.page';
import { MfaPage } from './pages/mfa/mfa.page';
import { authRedirectGuard } from '../guards/auth-redirect.guard';

const routes: Routes = [
  {
      path: 'login',
      component: LoginPage,
      canActivate: [authRedirectGuard],
      title: 'Login',
  },
  {
      path: 'authenticate',
      component: AuthenticatePage,
      title: 'Authenticate',
  },
  {
      path: 'reset-password',
      component: ResetPasswordPage,
      canActivate: [authRedirectGuard],
      title: 'Reset Password',
  },
  {
      path: 'mfa',
      component: MfaPage,
      title: 'Two-Factor Authentication',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
